import { IntegrationsActions } from "./types";
var initialState = {
    integrations: {}
};
export function integrationsReducer(state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case IntegrationsActions.SET_INTEGRATION_CONFIG:
            var setAction = action;
            return Object.assign({}, state, {
                integrations: Object.assign({}, state.integrations, (_a = {},
                    _a[setAction.payload.key] = setAction.payload,
                    _a)),
            });
        case IntegrationsActions.CLEAR_INTEGRATION_CONFIG:
            var clearAction = action;
            return Object.assign({}, state, {
                integrations: Object.assign({}, state.integrations, (_b = {},
                    _b[clearAction.payload] = undefined,
                    _b)),
            });
        case IntegrationsActions.INTEGRATIONS_EVENT_QUERY_PARAMS_FOUND:
            return state;
        default:
            return state;
    }
}
